declare const translations: { [key: string]: string };

export const useTranslation = () => {
    const _e = (text: string) => {
        if (text in translations) {
            return translations[text];
        } else {
            return text;
        }
    };
    return { _e };
};
